<template>
  <div>
    <Toast
      :show="toast.show && isSuccessToast"
      :message="toast.message"
      :type="toast.type"
    />
    <NewToast
      :show="toast.show && !isSuccessToast"
      :message="toast.message"
      :type="toast.type"
      :error-data="errorData"
    />
    <Loading :show="isLoading" />
    <router-view />
  </div>
</template>

<script>
import { Toast, NewToast, Loading } from '@/packages/ui/components';
import { mapGetters, mapState } from 'vuex';

export default {
  name: "Master",
  components: {
    Toast,
    Loading,
    NewToast,
  },
  computed: {
    ...mapState({
      toast: (state) => state.ui.toast,
    }),
    ...mapGetters({
      isLoading: 'ui/isLoading',
    }),
    isSuccessToast() {
      return this.toast.type === 'success';
    },
    errorData() {
      return {
        message: this.toast?.message,
        sentryTransactionId: this.toast?.sentryTransactionId,
        release: this.$consts.APP_VERSION,
      };
    },
  },
};
</script>
<style lang="scss">
body,
html {
  background-color: white;
}
</style>
